/* eslint-disable no-useless-computed-key */
import DownloadIcon from '@mui/icons-material/Download';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar, Button, Card, FormControlLabel, FormGroup, Grid, IconButton, Switch, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { Api } from '../../../../../api/api';
import { setAllUsers } from '../../../../../redux/slices/users/users';
import { endPoints } from '../../../../../api/apiEndpoints';
import { colors } from '../../../../../utils';
import InputControl from '../../../../../components/input/InputControl';
import { Flex, MarginHandler } from '../../../../../styledComponents';
import ButtonCom from '../../../../../components/button/ButtonCom';
import TransitionsModal from '../../../../../components/modal/Modal';
import Table from '../../../../../components/table/Table';
import { errorNotify, successNotify } from '../../../../../utils/helper';
import FilledSelectOption from '../../../../../components/input/FilledSelectOption';

const styles = {
	card: {
		padding: "2rem",
		border: "none",
		boxShadow: "none",
		width: "90%"
	},
	cols: {
		padding: "1rem",
	}
}
const Profile = (props) => {
	const { companyDetails } = props

	const dispatch = useDispatch();
	const { colorWhite, colorPrimary } = colors;
	const { users } = useSelector((state) => state?.users);
	const { clientId } = useSelector((state) => state?.activeAccount);

	const [isEditing, setIsEditing] = useState(false);
	const [formData, setFormData] = useState({
		logo: companyDetails.logo,
		company_name: companyDetails.company_name,
		number: companyDetails.number,
		email: companyDetails.email,
		address: companyDetails.address,
		landline_number: companyDetails.landline_number,
		ntn: companyDetails.ntn,
		enabled: companyDetails.enabled,
	});


	const handleChange = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.value,
		}));
	};
	const handleChangeSwitch = (e) => {
		setFormData((prevState) => ({
			...prevState,
			[e.target.name]: e.target.checked,
		}));
	};

	const getAllUsers = async () => {
		try {
			const response = await Api?.post(endPoints?.users?.list, {
				"client_id": companyDetails.id,
				"limit": 20,
				"page": 1
			}, {
				headers: {
					'xt-user-token': null
				}
			});
			dispatch(
				setAllUsers(
					response?.data?.data?.agentList?.map((d, index) => ({
						index: index + 1,
						id: d?.id,
						company_name: d?.company_name,
						email: d?.email,
						number: d?.number,
						enabled: d?.enabled,
					})
					),
				),
			);
		} catch (error) {
			console.error(error);
		}
	};
	useEffect(() => {
		getAllUsers()
	}, [])

	const handleSubmit = async () => {

		// try {
		// 	const response = await Api?.put(`${endPoints?.users?.update}/${formData.id}`, {
		// 		password: formData.password,
		// 		clientId: companyDetails.id,
		// 	}, {
		// 		headers: {
		// 			'xt-user-token': null
		// 		}
		// 	});
		// 	console.log(response)
		// 	successNotify("User Updated Successfully")


		// } catch (error) {
		// 	console.error(error);

		// }

	};

	return (
		<>
			<Card style={styles.card}>

				<Grid container spacing={2} marginTop={5}>

					<Grid xs={12} style={styles.cols}>
						{formData?.logo &&
							<Avatar sx={{ width: 56, height: 56, margin: "1em auto", border: "1px solid lightgrey" }} alt="icon" src={formData?.logo} />
						}
					</Grid>

					<Grid xs={6} style={styles.cols}>

						<InputControl
							state={formData?.company_name}
							onChange={handleChange}
							label='First Name'
							name='firstname'
						/>

					</Grid>

					<Grid xs={6} style={styles.cols}>

						<InputControl
							state={formData?.number}
							onChange={handleChange}
							label='Number'
							name='number'
							type="number"
						/>
					</Grid>
					<Grid xs={6} style={styles.cols}>

						<InputControl
							state={formData?.email}
							onChange={handleChange}
							label='Email'
							name='email'
							type="email"
						/>
					</Grid>
					<Grid xs={6} style={styles.cols}>

						<InputControl
							state={formData?.address}
							onChange={handleChange}
							label='Address'
							name='address'
							type="address"
						/>
					</Grid>

					<Grid xs={6} style={styles.cols}>

						<InputControl
							state={formData?.landline_number}
							onChange={handleChange}
							label='Landline Number'
							name='landline_number'
						/>
					</Grid>
					<Grid xs={6} style={styles.cols}>

						<InputControl
							state={formData?.ntn}
							onChange={handleChange}
							label='NTN'
							name='ntn'
						/>
					</Grid>
					<Grid xs={10} md={10} lg={11} style={styles.cols}>
						<MarginHandler width='100%'>
							<FormGroup>
								<FormControlLabel control={<Switch onChange={handleChangeSwitch} checked={formData?.enabled} name='enabled' />} label="Enable" />
							</FormGroup>
						</MarginHandler>
					</Grid>
					<Grid xs={2} md={2} lg={1} style={styles.cols}>
						<ButtonCom btnTitle='Update' disabled onClickHandler={handleSubmit} />
					</Grid>

				</Grid>

			</Card>
		</>
	);
};

export default Profile;
